export function getFileExtension(file: File) {
  return '.' + file.name.toLowerCase().split('.').pop();
}

export async function urltoFile(
  url: string,
  filename: string,
  mimeType: string,
) {
  if (url.startsWith('data:')) {
    const arr = url.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], filename, { type: mime || mimeType });
    return file;
  }

  const result = await fetch(url);
  const arrayBuffer = await result.arrayBuffer();
  return new File([arrayBuffer], filename, { type: mimeType });
}

export function downloadFile(url: string, name?: string) {
  const a = document.createElement('a');
  a.href = url;
  a.download = name || 'download';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

const FILE_EXTENSIONS_BY_MIME_TYPE: Record<string, string> = {
  'application/pdf': '.pdf',
  'image/gif': '.gif',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'text/csv': '.csv',
  'text/plain': '.txt',
};

export async function downloadCrossOriginFile(url: string, name?: string) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to download file: ${response.status}`);
  }

  const blob = await response.blob();
  const extension = FILE_EXTENSIONS_BY_MIME_TYPE[blob.type.toLowerCase()];
  const downloadName =
    name && extension && !/\.[a-z0-9]{1,10}$/i.test(name)
      ? `${name}${extension}`
      : name;
  const blobUrl = URL.createObjectURL(blob);

  try {
    downloadFile(blobUrl, downloadName);
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}

export async function blobUrlToBase64(blobUrl: string): Promise<string> {
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      // Remove data URL prefix if present
      const base64Data = base64String.includes(',')
        ? base64String.split(',')[1]
        : base64String;
      resolve(base64Data);
    };
    reader.onerror = () => {
      reject(new Error('Failed to read blob as base64'));
    };
    reader.readAsDataURL(blob);
  });
}
